export const getCityZoneByCityZoneId = (currentCity, cityZoneId) => {
  if (currentCity && currentCity.zones)
    return currentCity.zones.find((zone) => zone.id === cityZoneId);
  return null;
};
